import React from "react";
import "../myschedule.scss";
import "./viewLog.scss";
import ViewLogsHeader from "./ViewLogsHeader";
import ViewLogsCell from "./ViewLogsCell";
import NoDataComponent from "../../../common/NoDataUI/NoDataComponent";
import NoDataImage from "../../../../assets/Nodata.svg";

const ViewLogsTable = ({
  headerData,
  tableData,
  logType,
  applyParams,
  selectedRadioBtn,
  logFilterData,
}) => {
  const createHeader = () => {
    return (
      <>
        <div className="view-logs-header pr-3">
          {headerData && (
            <ViewLogsHeader
              headerData={headerData}
              applyParams={applyParams}
              selectedRadioBtn={selectedRadioBtn}
              logFilterData={logFilterData}
            />
          )}
        </div>
      </>
    );
  };
  const createTableContent = (data) => {
    return data?.map((obj, ind) => {
      return (
        <div className="w-100 mr-1" key={ind} style={{ borderRadius: "4px" }}>
          <ViewLogsCell
            cellData={obj}
            logType={logType}
            selectedRadioBtn={selectedRadioBtn}
          />
        </div>
      );
    });
  };
  const createTable = () => {
    return (
      <>
        {createHeader()}
        {tableData.length > 0 ? (
          <div className="view-logs-table-scroll">
            {createTableContent(tableData)}
          </div>
        ) : (
          <div className="view-logs-no-data-component">
            <NoDataComponent image={NoDataImage} heading={"No Logs Found"} />
          </div>
        )}
      </>
    );
  };
  return <>{createTable()}</>;
};
export default ViewLogsTable;
